module.exports = {
          srcSet: __webpack_public_path__ + "5cbb14c43acf7d613b7ad59c4a962a8f-430.png"+" 430w",
          images:[ {path: __webpack_public_path__ + "5cbb14c43acf7d613b7ad59c4a962a8f-430.png",width: 430,height: 605}],
          src: __webpack_public_path__ + "5cbb14c43acf7d613b7ad59c4a962a8f-430.png",
          toString:function(){return __webpack_public_path__ + "5cbb14c43acf7d613b7ad59c4a962a8f-430.png"},
          
          width: 430,
          height: 605
        }